import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { bootstrapQueryOptions, sessionQueryOptions } from "~/app/api/pageData";
import { queryClient } from "~/app/queryClient";
import { createStorefrontRouter } from "~/app/router/storefrontRouter";
import { StorefrontShellPropsProvider } from "~/app/router/storefrontShellPropsContext";
import type { StorefrontShellProps } from "./types";

export function StorefrontShellRouterHost(props: StorefrontShellProps) {
  const bootstrap = useQuery(bootstrapQueryOptions());
  const session = useQuery(sessionQueryOptions());
  const router = useMemo(() => createStorefrontRouter(queryClient), []);

  if (!bootstrap.data || !session.data) {
    return null;
  }

  return (
    <StorefrontShellPropsProvider value={props}>
      <RouterProvider router={router} />
    </StorefrontShellPropsProvider>
  );
}

export const StorefrontShell = StorefrontShellRouterHost;
